import DonutChart from './donut_chart';

export default DonutChart;
